import axios from 'axios'
import { apiURL } from '@/config'

const anexos = {
  namespaced: true,
  actions: {
    downloadAnexo ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', {}, { root: true })

      const config = {
        params: {
          url: payload.path
        },
        responseType: 'arraybuffer'
      }

      axios.get(`${apiURL}/anexos/download`, config).then((response) => {
        dispatch('utils/hideLoading', {}, { root: true })

        const filename = payload.name
        const headers = response.headers
        const blob = new Blob([response.data], { type: headers['content-type'] })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }, () => {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
      })
    }
  }
}

export default anexos



// WEBPACK FOOTER //
// ./src/vuex/modules/anexos.js